import { Box, Step, StepLabel, Stepper } from '@mui/material'
import * as React from 'react'
import PageSection from '../../../Constants&Theme/PageSection'
import StudyPageToggle from '../StudyPageToggle'
import StudyDataSelectToggle from './StudyDataSelectToggle'
import { useLocation } from 'react-router-dom'

function EntryStepsHeader({ step, children }: { step: number; children: any }) {
  const steps = ['Select', 'Enter Data', 'Complete & Save']
  const { pathname } = useLocation()
  return (
    <PageSection
      title={
        step < 4 ?
          <Box sx={{ p: 2, width: 1, maxWidth: 'md' }}>
            <Stepper activeStep={step}>
              {steps.map((label) => {
                return (
                  <Step key={label}>
                    <StepLabel
                      sx={{
                        '& .MuiStepLabel-label': {
                          fontSize: '1.2rem',
                          fontWeight: 'bold',
                        },
                      }}
                    >
                      {label}
                    </StepLabel>
                  </Step>
                )
              })}
            </Stepper>
          </Box>
        : 'Error'
      }
      leftDecorator={<StudyPageToggle />}
      rightDecorator={
        pathname.includes('select') ? <StudyDataSelectToggle /> : undefined
      }
    >
      {children}
    </PageSection>
  )
}

export default EntryStepsHeader
